module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('section', {
    staticClass: "home-character"
  }, [_c('h1', [_vm._v("盘活企业现金流")]), _vm._v(" "), _c('h2', [_vm._v("降低供应链中的成本，提升整体资金周转效率，为供应链各方创造价值。")]), _vm._v(" "), _c('div', {
    staticClass: "box-container"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', [_vm._v("我是大型企业")]), _vm._v(" "), _c('p', [_vm._v("我要盘活企业现金流，降低供应链中的成本")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('core')
      }
    }
  }, [_vm._v("进一步了解")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('core', 'form')
      }
    }
  }, [_vm._v("联系顾问团")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', [_vm._v("我是银行")]), _vm._v(" "), _c('p', [_vm._v("我要为优质企业提供资金，完成支小目标")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('institution')
      }
    }
  }, [_vm._v("进一步了解")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('institution', 'form')
      }
    }
  }, [_vm._v("联系资金组")])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "home-win"
  }, [_c('h1', {
    staticClass: "large"
  }, [_vm._v("享受共赢")]), _vm._v(" "), _c('h2', [_vm._v("降低供应链中的成本，提升整体资金周转效率，为供应链各方创造价值。")]), _vm._v(" "), _c('div', {
    staticClass: "box-container"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("我是大型企业")]), _vm._v(" "), _c('p', [_vm._v("企业等同于获得一张“信用卡”")]), _vm._v(" "), _c('p', [_vm._v("在获得经营性现金流的同时，不占用贷款和发债额度")]), _vm._v(" "), _c('div', {
    staticClass: "a-container"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('core', 'n1')
      }
    }
  }, [_vm._v("我想延长供应商账期")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('core', '1n')
      }
    }
  }, [_vm._v("我想提前收取经销商货款")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/home/visa@2x.png",
      "alt": "icon",
      "width": "240"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("我是银行")]), _vm._v(" "), _c('p', [_vm._v("响应国务院政策，完成中小微企业新开户数")]), _vm._v(" "), _c('p', [_vm._v("以及给中小微企业放款金额的指标")]), _vm._v(" "), _c('div', {
    staticClass: "a-container"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('institution')
      }
    }
  }, [_vm._v("我想开展供应链金融业务")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/home/bank@2x.png",
      "alt": "icon",
      "width": "280"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("我是供应商/经销商")]), _vm._v(" "), _c('p', [_vm._v("享受货款现结，延长账期")]), _vm._v(" "), _c('p', [_vm._v("扩大销售规模，无需再面对资金难题")]), _vm._v(" "), _c('div', {
    staticClass: "a-container"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('chain', 'n1')
      }
    }
  }, [_vm._v("我想提前收到货款")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('chain', '1n')
      }
    }
  }, [_vm._v("我想延长付款账期")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/home/iphone@2x.png",
      "alt": "icon",
      "width": "270"
    }
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "home-service"
  }, [_c('h1', {
    staticClass: "large"
  }, [_vm._v("全方位的供应链金融服务")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('service')
      }
    }
  }, [_vm._v("进一步了解")]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('section', {
    staticClass: "home-map"
  }, [_c('header', [_c('h1', [_vm._v("目前有80个省市的数万家中小企业使用群星平台")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/home/map@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("现在开始体验供应链金融服务")]), _vm._v(" "), _c('div', {
    staticClass: "download",
    on: {
      "click": function($event) {
        return _vm.topage('download?page=download-home')
      }
    }
  }, [_c('span', [_vm._v("下载方案")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/home/download@2x.png",
      "alt": "icon"
    }
  })])]), _vm._v(" "), _c('Footer', {
    staticClass: "home-footer",
    attrs: {
      "page": "download-home"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "home-case"
  }, [_c('h1', [_vm._v("专业团队&灵活方案")]), _vm._v(" "), _c('h2', [_vm._v("作为专注于供应链金融长尾的互联网交易平台，群星的团队拥有业内丰富的经验，")]), _vm._v(" "), _c('h2', [_vm._v("能够提供灵活的资金解决方案，您也将享受到其他金融公司无法支持的供应链金融服务。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "home-digit"
  }, [_c('div', {
    staticClass: "box-container"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v("154")]), _vm._v("家核心\n        "), _c('p', [_vm._v("多家核心企业在使用")]), _vm._v(" "), _c('p', [_vm._v("供应链金融平台")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v("80")]), _vm._v("个省市\n        "), _c('p', [_vm._v("数万家企业和供应商")]), _vm._v(" "), _c('p', [_vm._v("享受群星平台服务")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v("6")]), _vm._v("年经验\n        "), _c('p', [_vm._v("深耕多年的")]), _vm._v(" "), _c('p', [_vm._v("供应链金融业务经验")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v("130")]), _vm._v("亿元\n        "), _c('p', [_vm._v("群星金融贸易流量")]), _vm._v(" "), _c('p', [_vm._v("已达到130亿元")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-container"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/home/zijin_1@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("资金方案")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/home/data_1@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("数据分析")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/home/lianshu_1@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("链属营销")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/home/line_1@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("线上平台")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-361132aa"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/components/Home.vue
// module id = 1292
// module chunks = 26